import module from 'finanzas/module.js'
import template from './template.html'

function FinancesPosicionbancariaPrestamoInformacionComponent () {
  var $ctrl = this

  $ctrl.recalcular = recalcular

  function recalcular () {
    if (!($ctrl.data.importe > 0)) {
      $ctrl.data.interes = null
      $ctrl.data.capital = null
      $ctrl.data.financiamiento = []
      $ctrl.data.destinatario_importe = null

      return
    }

    $ctrl.data.interes = parseFloat(($ctrl.data.importe * $ctrl.data.interes_porcentaje).toFixed(2))
    $ctrl.data.capital = parseFloat(($ctrl.data.importe * ($ctrl.data.interes_porcentaje + 1)).toFixed(2))

    $ctrl.data.destinatario_importe = $ctrl.data.id_moneda === 1
      ? ($ctrl.data.importe / $ctrl.data.tipo_cambio)
      : ($ctrl.data.importe * $ctrl.data.tipo_cambio)
  }
}

module.component('financesPosicionbancariaPrestamoInformacion', {
  controller: FinancesPosicionbancariaPrestamoInformacionComponent,
  template,
  bindings: {
    data: '<',
    catalogos: '<',
  },
})



// WEBPACK FOOTER //
// ./src/finanzas/components/posicionbancaria/prestamo/informacion/component.js